import AuthZeroClient from "@/clients/AuthZeroClient";

class AuthZeroService {

    /**
     * Fetch members by organization ID.
     * @param {string} orgId 
     * @returns {Promise<Object[]>}
     */
    async getMembersByOrg(orgId) {
        return await AuthZeroClient.getMembersByOrg(orgId);
    }

    async getAssignableRolesAsync(){
        return await AuthZeroClient.getAssignableRoles();
    }

    /**
     * Create a new user.
     * @param {Object} userData 
     * @returns {Promise<Object>}
     */
    async createUser(userData) {
        return await AuthZeroClient.createUser(userData);
    }

    /**
     * Assign roles to a user.
     * @param {string} userId 
     * @param {string[]} roles 
     * @returns {Promise<Object>}
     */
    async assignRoles(orgId, userId, previousRoleId, newRoleId) {
        return await AuthZeroClient.assignRoles(orgId, userId, previousRoleId, newRoleId);
    }

    /**
     * Delete a user.
     * @param {string} organizationId 
     * @param {string} userId 
     * @returns {Promise<void>}
     */
    async deleteUser(organizationId, userId) {
        return await AuthZeroClient.deleteUser(organizationId, userId);
    }

    async getOrganizationById(organizationId){
        return await AuthZeroClient.getOrganizationById(organizationId);
    }
}

export default new AuthZeroService();
